import { render, staticRenderFns } from "./DegreeInput.vue?vue&type=template&id=638aa31e&"
import script from "./DegreeInput.vue?vue&type=script&lang=js&"
export * from "./DegreeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports